import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

import { Input } from "components"
import classes from "./InventorySearch.module.scss"

const InventorySearch = props => {
  const { onSearch } = props

  const [t] = useTranslation()

  const [input, setInput] = useState("")

  const timeout = useRef()

  const handleChange = (e) => {
    const value = e.target.value

    clearTimeout(timeout.current)

    setInput(value)

    timeout.current =
      setTimeout(() => {
        onSearch(value.trim())
      }, 800)
  }

  useEffect(() => {
    return () => { clearTimeout(timeout.current) }
  }, [])

  return (
    <div className={classes["inputContianer"]}>
      <Input
        value={input}
        className={classes["input"]}
        placeholder={t("جست_و_جو_با_اسم_یا_کد_کالا")}
        onChange={handleChange}
      />
    </div>

  )
}

export default InventorySearch